export const topRecruiters = ['#971FF5', '#165DFF', '#F7BA1E', '#0FC6C2'];
export const others = '#F77234';
